module.exports = __webpack_public_path__ + "static/media/2022_bretpetersen_resume.21e9ce2c.pdf";